module.exports = __webpack_public_path__ + "images/emoji/arrows_counterclockwise.6814bfe0fcd82a49b660.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrows_counterclockwise.png
// module id = gmEd
// module chunks = 2